<template>
  <div class="proposal-table">
    <div
      class="d-flex align-center bg-stake-lighter has-border border-stake rounded-8 gray--text text-6 font-weight-medium px-6 py-2"
    >
      <div style="width:50px">Id</div>
      <div class="flex-3 text-left">Title</div>
      <div style="width:120px" class="text-left pl-5">Status</div>
      <div class="flex-2 text-right pr-3">Voting Start</div>
      <div class="flex-2 text-right">Submit Time</div>
      <div class="flex-2 text-right">Total Deposit</div>
    </div>
    <proposal-row
      v-for="(item, index) in proposalItems"
      :key="item.token"
      :dataItem="item"
      :hasDivider="index > 0"
    />
  </div>
</template>

<script>
import ProposalRow from "./ProposalRow.vue";

export default {
  components: {
    ProposalRow,
  },
  props: {
    proposalItems: Array,
  },
};
</script>
